export const USER_ADD_RESULT = Symbol('USER_ADD_RESULT');
